import React, { useState } from 'react'
import { NavLink, Navigate } from 'react-router-dom'
import { Button, Form, Grid, Segment, Message } from 'semantic-ui-react'
import { useAuth } from '../context/AuthContext'
import { stockyApi } from '../misc/StockyApi'
import { parseJwt, handleLogError } from '../misc/Helpers'
import AddTrackingScript from '../tracking/AddTrackingScript';
import PaymentBlockedCard from '../payments/PaymentBlockedCard'
import { clearPaymentBlockedNotice, readPaymentBlockedNotice } from '../payments/paymentBlockedNotice'

function Login() {
  const Auth = useAuth()
  const isLoggedIn = Auth.userIsAuthenticated()

  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState(() => window.sessionStorage.getItem('auth:notice') || '')
  // Seeded from the notice left by a forced logout (401 PAYMENT_BLOCKED on an open session).
  const [paymentBlocked, setPaymentBlocked] = useState(() => readPaymentBlockedNotice())

  const handleInputChange = (e, { name, value }) => {
    if (name === 'username') {
      setUsername(value)
    } else if (name === 'password') {
      setPassword(value)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!(username && password)) {
      setErrorMessage('Ingresá tu usuario y contraseña.')
      return
    }

    try {
      const response = await stockyApi.authenticate(username, password)
      const { accessToken } = response.data
      const data = parseJwt(accessToken)
      const authenticatedUser = { data, accessToken, profile: response.data.user }

      Auth.userLogin(authenticatedUser)
      window.sessionStorage.removeItem('auth:notice')

      setUsername('')
      setPassword('')
      setErrorMessage('')
      setPaymentBlocked(null)
      clearPaymentBlockedNotice()
    } catch (error) {
      handleLogError(error)
      if (error?.response?.status === 402 && error?.response?.data?.code === 'PAYMENT_BLOCKED') {
        setPaymentBlocked({
          amount: error.response.data.nextPaymentAmount ?? null,
          dueDate: error.response.data.nextPaymentDueDate ?? null,
        })
        setErrorMessage('')
        return
      }
      setPaymentBlocked(null)
      const responseMessage = error?.response?.data?.message
      setErrorMessage(
        error?.response?.data?.code === 'ACCOUNT_SUSPENDED'
          ? responseMessage
          : 'El usuario o la contraseña ingresados no son correctos.',
      )
    }
  }

  if (isLoggedIn) {
    return <Navigate to={Auth.isAdmin() ? '/users' : '/inicio'} replace />
  }

  const fieldsDisabled = Boolean(paymentBlocked)

  return (
    <Grid textAlign='center'>
      <AddTrackingScript />
      <Grid.Column style={{ maxWidth: 450 }}>
        {paymentBlocked ? <PaymentBlockedCard amount={paymentBlocked.amount} /> : null}
        <Form size='large' onSubmit={handleSubmit}>
          <Segment>
            <Form.Input
              fluid
              autoFocus={!fieldsDisabled}
              name='username'
              icon='user'
              iconPosition='left'
              placeholder='Username'
              value={username}
              onChange={handleInputChange}
              disabled={fieldsDisabled}
            />
            <Form.Input
              fluid
              name='password'
              icon='lock'
              iconPosition='left'
              placeholder='Password'
              type='password'
              value={password}
              onChange={handleInputChange}
              disabled={fieldsDisabled}
            />
            <Button color='violet' fluid size='large' disabled={fieldsDisabled}>Login</Button>
          </Segment>
        </Form>
        {fieldsDisabled ? (
          <div style={{ marginTop: 12 }}>
            <Button type='button' basic size='small' onClick={() => { clearPaymentBlockedNotice(); setPaymentBlocked(null) }}>
              Ya pagué, quiero reintentar
            </Button>
          </div>
        ) : null}
        {errorMessage && !paymentBlocked && (
          <Message negative style={{ position: 'absolute', top: '95%', right: '10px', fontSize: '12px', padding: '5px', width: '200px' }}>
            {errorMessage}
          </Message>
        )}
      </Grid.Column>
    </Grid>
  )
}

export default Login
